/*
 * Шаги курса «Шахматы» на общей платформе курсов (course-kit.js).
 *
 * Доска, правила, движок и задачи — те же, что у /chess: ChessBoard,
 * ChessRules, ChessNotation, ChessEngine (Stockfish), ChessMaia, ChessPuzzles.
 * Своего движка правил здесь нет — только уроки поверх него.
 *
 *   chess-tap     — нажать клетку по имени / все поля, куда идёт фигура / все
 *                   клетки из списка (висящие фигуры, связанная фигура…)
 *   chess-move    — найти ход или короткий форсированный вариант; ответы
 *                   соперника записаны; «мат» принимает любой матующий ход
 *   chess-play    — доиграть позицию против движка с целью: мат за N ходов,
 *                   провести пешку, удержать ничью N ходов; или партия с Maia
 *   chess-puzzles — серия задач Lichess (CC0) по теме и рейтингу
 *   figure 'board' — неподвижная диаграмма с подсветкой клеток
 *
 * Все позиции и решения проверены движком перед публикацией —
 * docs/why/chess-course.md, раздел «Проверка».
 */
(function () {
    'use strict';
    var K = window.CourseKit;
    if (!K) return;
    var CH = window.__CHESS_COURSE || {};
    var FIG = { K: '♔', Q: '♕', R: '♖', B: '♗', N: '♘' };

    function R() { return window.ChessRules; }
    function sqIndex(name) {
        if (!name || name.length < 2) return -1;
        return (name.charCodeAt(0) - 97) + (parseInt(name[1], 10) - 1) * 8;
    }
    function sqName(i) { return 'abcdefgh'[i & 7] + ((i >> 3) + 1); }
    function x88(i) { return (i >> 3) * 16 + (i & 7); }

    function san(state, move) {
        var s = '';
        try { s = window.ChessNotation.toSAN(state, move); } catch (_) { s = R().moveToUCI(move); }
        return s.replace(/^([KQRBN])/, function (m, c) { return FIG[c]; }).replace(/=([QRBN])/, function (m, c) { return '=' + FIG[c]; });
    }
    function lineSan(fen, ucis) {
        var st = R().fromFEN(fen), out = [];
        for (var i = 0; i < ucis.length; i++) {
            var mv = R().moveFromUCI(st, ucis[i]);
            if (!mv) break;
            var n = st.fullmove, w = st.turn === 'w';
            out.push((w ? n + '. ' : (i === 0 ? n + '… ' : '')) + san(st, mv));
            st = R().applyMove(st, mv);
        }
        return out.join(' ');
    }

    function a11y() {
        var A = CH.a11y || {};
        return {
            pieces: A.pieces || {}, white: A.white, black: A.black, empty: A.empty, selected: A.selected,
            move_here: A.move_here, capture: A.capture, check: A.check, last_move: A.last_move
        };
    }

    /* Доска в карточке шага. o: {fen, orient, movesFor, onMove, onEdit, interactive} */
    function mkBoard(host, api, o) {
        var wrap = api.el('div', 'crs-chess');
        var bh = api.el('div', 'crs-cb');
        wrap.appendChild(bh);
        host.appendChild(wrap);
        var state = R().fromFEN(o.fen);
        var b = window.ChessBoard.create(bh, {
            orientation: o.orient || state.turn,
            coordinates: true,
            pieceSet: 'classic',
            view: '2d',
            a11y: a11y(),
            ariaLabel: api.tt('chess_board'),
            movesFor: o.movesFor || function () { return []; },
            onMove: o.onMove || function () {},
            onEditSquare: o.onEdit || null,
            onEditMove: o.onEdit ? function (from, to) { o.onEdit(to); } : null,
            onIdle: o.onIdle || null
        });
        if (o.onEdit) b.setEditMode(true);
        b.setInteractive(o.interactive !== false);
        b.setPosition(state);
        api.onCleanup(function () { try { b.destroy(); } catch (_) {} });
        return { b: b, wrap: wrap, state: state };
    }
    function sqEl(b, i) { return b.el.querySelector('.cb-sq[data-sq="' + i + '"]'); }
    function mark(b, i, cls, on) {
        var e = sqEl(b, i);
        if (e) e.classList.toggle(cls, on !== false);
    }
    function turnLine(api, st) {
        return api.tt(st.turn === 'w' ? 'chess_white_to_move' : 'chess_black_to_move');
    }
    function status(host, api) {
        var p = api.el('p', 'crs-chess-status');
        p.setAttribute('aria-live', 'polite');
        host.appendChild(p);
        return p;
    }

    /* ── рисунок: неподвижная позиция ──────────────────────────────── */
    K.figure('board', function (box, fig, step, api) {
        box.classList.add('crs-fig-board');
        var bd = mkBoard(box, api, { fen: fig.fen, orient: fig.orient, interactive: false });
        var m = fig.marks || {};
        (m.ok || []).forEach(function (n) { mark(bd.b, sqIndex(n), 'crs-sq-ok'); });
        (m.bad || []).forEach(function (n) { mark(bd.b, sqIndex(n), 'crs-sq-bad'); });
        (m.show || []).forEach(function (n) { mark(bd.b, sqIndex(n), 'crs-sq-show'); });
        if (fig.last) bd.b.markLastMove(sqIndex(fig.last.slice(0, 2)), sqIndex(fig.last.slice(2, 4)));
    });

    /* ── нажать клетки ─────────────────────────────────────────────── */
    K.step('chess-tap', {
        mount: function (host, step, api) {
            var t = step.t || {};
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            var mode = step.mode || 'square';
            var st0 = R().fromFEN(step.fen);
            var want = {};
            var from = step.square ? sqIndex(step.square) : -1;
            if (mode === 'square') want[sqIndex(step.target)] = 1;
            else if (mode === 'moves') {
                var s = R().cloneState(st0);
                var piece = s.board[x88(from)];
                // ход фигуры спрашивается и тогда, когда сейчас ход соперника
                s.turn = piece > 0 ? 'w' : 'b';
                R().legalMoves(s).forEach(function (mv) { if (R().to64(mv.from) === from) want[R().to64(mv.to)] = 1; });
            } else (step.targets || []).forEach(function (n) { want[sqIndex(n)] = 1; });
            var total = Object.keys(want).length;
            var found = {}, wrong = 0, done = false;
            var info = status(host, api);
            var bd = mkBoard(host, api, { fen: step.fen, orient: step.orient || 'w', onEdit: tap });
            if (from >= 0) mark(bd.b, from, 'crs-sq-from');
            function names(obj) { return Object.keys(obj).map(Number).sort(function (a, b) { return a - b; }).map(sqName).join(', '); }
            function update() {
                if (mode !== 'square') info.textContent = api.tt('chess_found', { n: Object.keys(found).length, total: total });
            }
            function finish(gave) {
                if (done) return;
                done = true;
                bd.b.setInteractive(false);
                var n = Object.keys(found).length;
                var missing = {};
                Object.keys(want).forEach(function (k) { if (!found[k]) { missing[k] = 1; mark(bd.b, +k, 'crs-sq-show'); } });
                var score = total ? Math.max(0, n / total - wrong * 0.15) : 1;
                var ok = !gave && n === total && wrong <= (mode === 'square' ? 0 : 1);
                api.answer({ correct: ok, score: ok ? score : Math.min(score, 0.6), reveal: ok ? null : names(mode === 'square' ? want : missing) || null });
            }
            function tap(sq) {
                if (done || sq < 0) return;
                if (mode === 'square') {
                    if (want[sq]) { found[sq] = 1; mark(bd.b, sq, 'crs-sq-ok'); }
                    else { wrong++; mark(bd.b, sq, 'crs-sq-bad'); }
                    finish(false);
                    return;
                }
                if (found[sq]) return;
                if (want[sq]) {
                    found[sq] = 1;
                    mark(bd.b, sq, 'crs-sq-ok');
                    update();
                    if (Object.keys(found).length === total) finish(false);
                } else {
                    wrong++;
                    mark(bd.b, sq, 'crs-sq-bad');
                    setTimeout(function () { if (!done) mark(bd.b, sq, 'crs-sq-bad', false); }, 900);
                    info.textContent = api.tt('chess_not_this', { sq: sqName(sq) }) + ' ' + api.tt('chess_found', { n: Object.keys(found).length, total: total });
                    if (wrong >= 2) api.secondary(api.t('spot_giveup'), function () { finish(true); });
                }
            }
            if (mode !== 'square') {
                api.primary(api.t('check'), function () { finish(false); });
                update();
            } else {
                info.textContent = api.tt('chess_tap_square');
            }
        }
    });

    /* ── найти ход / вариант ───────────────────────────────────────── */
    K.step('chess-move', {
        mount: function (host, step, api) {
            var t = step.t || {};
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            var start = R().fromFEN(step.fen);
            var line = step.line || [];
            var alts = step.alts || {};
            var info = status(host, api);
            var st = start, ply = 0, misses = 0, hinted = false, done = false, busy = false;
            var userColor = null;
            var bd = mkBoard(host, api, {
                fen: step.fen,
                // доска — стороной решающего: после хода-подготовки ходит другой цвет
                orient: step.orient || (step.setup ? (start.turn === 'w' ? 'b' : 'w') : start.turn),
                movesFor: function (sq) {
                    if (busy || done) return [];
                    var out = [];
                    R().legalMoves(st).forEach(function (mv) {
                        if (R().to64(mv.from) === sq && out.indexOf(R().to64(mv.to)) < 0) out.push(R().to64(mv.to));
                    });
                    return out;
                },
                onMove: onMove,
                onIdle: function () { if (busy) info.textContent = api.tt('chess_wait'); }
            });
            function setPos(next, mv, animate) {
                st = next;
                bd.b.setPosition(st, { animate: animate !== false });
                if (mv) bd.b.markLastMove(R().to64(mv.from), R().to64(mv.to));
                bd.b.markCheck(R().inCheck(st, st.turn) ? R().to64(R().kingSquare(st.board, st.turn)) : null);
            }
            function begin() {
                if (step.setup) {
                    busy = true;
                    info.textContent = api.tt('chess_watch');
                    setTimeout(function () {
                        if (!api.alive()) return;
                        var mv = R().moveFromUCI(st, step.setup);
                        if (mv) setPos(R().applyMove(st, mv), mv);
                        busy = false;
                        userColor = st.turn;
                        info.textContent = turnLine(api, st);
                    }, 700);
                } else {
                    userColor = st.turn;
                    info.textContent = turnLine(api, st);
                }
            }
            function accepts(mv) {
                var u = R().moveToUCI(mv);
                var ok = [line[ply]].concat(alts[String(ply)] || []);
                if (ok.indexOf(u) >= 0) return true;
                if (step.mate && ply >= line.length - 1) {
                    var after = R().applyMove(st, mv);
                    return R().isCheckmate(after);
                }
                return false;
            }
            function pickMove(from, to, cb) {
                var cands = R().legalMoves(st).filter(function (mv) { return R().to64(mv.from) === from && R().to64(mv.to) === to; });
                if (!cands.length) return;
                if (cands.length === 1) { cb(cands[0]); return; }
                bd.b.askPromotion(st.turn, to & 7, function (type) {
                    var m = cands.filter(function (c) { return c.promotion === type; })[0];
                    if (m) cb(m);
                });
            }
            function onMove(from, to) {
                if (busy || done) return;
                pickMove(from, to, function (mv) {
                    if (accepts(mv)) {
                        setPos(R().applyMove(st, mv), mv);
                        ply++;
                        if (ply >= line.length || (step.mate && R().isCheckmate(st))) { solved(); return; }
                        busy = true;
                        info.textContent = api.tt('chess_good_reply');
                        setTimeout(function () {
                            if (!api.alive()) return;
                            var rep = R().moveFromUCI(st, line[ply]);
                            if (rep) setPos(R().applyMove(st, rep), rep);
                            ply++;
                            busy = false;
                            if (ply >= line.length) { solved(); return; }
                            info.textContent = api.tt('chess_continue');
                        }, 650);
                    } else {
                        misses++;
                        var bad = R().applyMove(st, mv);
                        bd.b.setPosition(bad, { animate: true });
                        busy = true;
                        setTimeout(function () {
                            if (!api.alive()) return;
                            bd.b.setPosition(st, { animate: true });
                            busy = false;
                            if (misses >= 2) failed();
                            else info.textContent = api.tt('chess_try_again');
                        }, 600);
                    }
                });
            }
            function solved() {
                done = true;
                bd.b.setInteractive(false);
                var score = misses || hinted ? 0.5 : 1;
                api.answer({ correct: true, score: score, explain: (t.explain || '') + '\n\n' + api.tt('chess_line', { line: lineSan(afterSetupFen(), line) }) });
            }
            function failed() {
                done = true;
                bd.b.setInteractive(false);
                var full = lineSan(afterSetupFen(), line);
                // показать решение на доске
                var s = R().fromFEN(afterSetupFen()), k = 0;
                (function play() {
                    if (!api.alive() || k >= line.length) return;
                    var mv = R().moveFromUCI(s, line[k]);
                    if (!mv) return;
                    s = R().applyMove(s, mv);
                    bd.b.setPosition(s, { animate: true });
                    bd.b.markLastMove(R().to64(mv.from), R().to64(mv.to));
                    k++;
                    setTimeout(play, 700);
                })();
                api.answer({ correct: false, reveal: full });
            }
            function afterSetupFen() {
                if (!step.setup) return step.fen;
                var s = R().fromFEN(step.fen);
                var mv = R().moveFromUCI(s, step.setup);
                return mv ? R().toFEN(R().applyMove(s, mv)) : step.fen;
            }
            api.secondary(api.tt('chess_hint'), function () {
                if (done || busy || ply >= line.length) return;
                hinted = true;
                var mv = R().moveFromUCI(st, line[ply]);
                if (mv) bd.b.flashHint(R().to64(mv.from), R().to64(mv.from));
                info.textContent = api.tt('chess_hint_text', { sq: mv ? R().squareName(mv.from) : '' });
            });
            begin();
        }
    });

    /* ── движок ────────────────────────────────────────────────────── */
    var sfReady = null;
    function stockfish() {
        if (!sfReady) {
            sfReady = (window.ChessEngine && window.ChessEngine.init ? window.ChessEngine.init() : Promise.reject(new Error('no engine')))
                .then(function () { if (window.ChessEngine.available === false) throw new Error('engine unavailable'); return window.ChessEngine; });
            sfReady.catch(function () { sfReady = null; });
        }
        return sfReady;
    }
    var maiaCfg = false;
    function maia(rating) {
        if (!window.ChessMaia || typeof WebAssembly === 'undefined') return null;
        if (!maiaCfg && CH.maia) {
            maiaCfg = true;
            window.ChessMaia.configure({
                workerUrl: CH.maia.workerUrl,
                encoderUrl: CH.maia.encoderUrl,
                modelBase: CH.maia.modelBase,
                ort: function () {
                    var b = window.__ortBuild && window.__ortBuild.pick({ cpuOnly: true });
                    return b ? { url: b.url, wasmBase: b.wasmBase, legacy: b.legacy } : { url: '/vendor/onnxruntime/ort.wasm.min.js', wasmBase: '/vendor/onnxruntime/', legacy: '' };
                },
                ortInitFailed: function (err, used) {
                    try { return !!(window.__ortBuild && window.__ortBuild.initFailed(err, used)); } catch (e) { return false; }
                }
            });
        }
        if (window.ChessMaia.available === false) return null;
        var rs = window.ChessMaia.RATINGS || [1100];
        var best = rs[0];
        rs.forEach(function (r) { if (Math.abs(r - rating) < Math.abs(best - rating)) best = r; });
        try { return window.ChessMaia.engine(best); } catch (_) { return null; }
    }
    function material(st, color) {
        var v = { 1: 1, 2: 3, 3: 3, 4: 5, 5: 9, 6: 0 }, s = 0;
        for (var i = 0; i < 128; i++) {
            if (i & 0x88) continue;
            var p = st.board[i];
            if (!p) continue;
            if ((p > 0) === (color === 'w')) s += v[Math.abs(p)];
        }
        return s;
    }

    /* ── доиграть позицию ──────────────────────────────────────────── */
    K.step('chess-play', {
        reviewable: false,
        mount: function (host, step, api) {
            var t = step.t || {};
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            var goal = step.goal || 'mate';
            var limit = step.moves || 0;
            var info = status(host, api);
            var st, userColor, used, busy, done = false, attempts = 0, fens, keys, startDiff, pendingLoss = false;
            var bd = mkBoard(host, api, {
                fen: step.fen,
                orient: step.orient || step.user,
                movesFor: function (sq) {
                    if (busy || done || st.turn !== userColor) return [];
                    var out = [];
                    R().legalMoves(st).forEach(function (mv) {
                        if (R().to64(mv.from) === sq && out.indexOf(R().to64(mv.to)) < 0) out.push(R().to64(mv.to));
                    });
                    return out;
                },
                onMove: onMove,
                onIdle: function () { if (busy) info.textContent = api.tt('chess_engine_thinking'); }
            });
            var eng = null, maiaEng = null;
            function setPos(next, mv) {
                st = next;
                fens.push(R().toFEN(st));
                keys.push(R().positionKey(st));
                bd.b.setPosition(st, { animate: true });
                if (mv) bd.b.markLastMove(R().to64(mv.from), R().to64(mv.to));
                bd.b.markCheck(R().inCheck(st, st.turn) ? R().to64(R().kingSquare(st.board, st.turn)) : null);
            }
            function goalLine() {
                var left = Math.max(0, limit - used);
                if (goal === 'mate') return api.tt('chess_goal_mate', { n: left });
                if (goal === 'promote') return api.tt('chess_goal_promote', { n: left });
                if (goal === 'draw') return api.tt('chess_goal_draw', { n: left });
                return turnLine(api, st);
            }
            function reset() {
                attempts++;
                st = R().fromFEN(step.fen);
                fens = [R().toFEN(st)];
                keys = [R().positionKey(st)];
                userColor = step.user || st.turn;
                used = 0;
                busy = false;
                pendingLoss = false;
                startDiff = material(st, userColor) - material(st, userColor === 'w' ? 'b' : 'w');
                bd.b.clearMarks();
                bd.b.setPosition(st);
                bd.b.setInteractive(true);
                info.textContent = goalLine();
                api.secondary(goal === 'game' ? api.tt('chess_resign') : api.tt('chess_restart'), goal === 'game' ? function () { end('resign'); } : reset);
                if (st.turn !== userColor) reply();
            }
            function onMove(from, to) {
                if (busy || done || st.turn !== userColor) return;
                var cands = R().legalMoves(st).filter(function (mv) { return R().to64(mv.from) === from && R().to64(mv.to) === to; });
                if (!cands.length) return;
                if (cands.length > 1) {
                    bd.b.askPromotion(st.turn, to & 7, function (type) {
                        var m = cands.filter(function (c) { return c.promotion === type; })[0];
                        if (m) played(m);
                    });
                } else played(cands[0]);
            }
            function played(mv) {
                setPos(R().applyMove(st, mv), mv);
                used++;
                if (judge(mv, true)) return;
                reply();
            }
            /* Итог после хода. true — попытка окончена. */
            function judge(mv, byUser) {
                var res = R().gameResult(st, keys);
                if (goal === 'mate') {
                    if (res && res.over && res.reason === 'checkmate') { end(byUser ? 'win' : 'lost'); return true; }
                    if (res && res.over) { end(res.reason === 'stalemate' ? 'stalemate' : 'drawn'); return true; }
                    if (byUser && used >= limit) { end('moves'); return true; }
                    return false;
                }
                if (goal === 'promote') {
                    if (byUser && mv.promotion) {
                        // Провал — только если новую фигуру можно взять даром. Защищённая
                        // фигура под ударом — это размен, после которого перевес остаётся
                        // (в Лусене ладья соперника меняется и остаётся ладья против короля).
                        var hit = R().isAttacked(st.board, mv.to, st.turn);
                        var guarded = R().isAttacked(st.board, mv.to, userColor);
                        end(!hit || guarded ? 'win' : 'unsafe');
                        return true;
                    }
                    if (res && res.over) { end(res.reason === 'checkmate' && !byUser ? 'lost' : 'drawn'); return true; }
                    var opp = userColor === 'w' ? 'b' : 'w';
                    var diff0 = material(st, userColor) - material(st, opp);
                    if (byUser) {
                        // Соперник остался с голым королём, а у ученика ладья или ферзь — выиграно,
                        // даже если пешка ушла в размен (в Лусене движок отдаёт ладью за пешку).
                        if (material(st, opp) === 0 && diff0 >= 5) { end('win'); return true; }
                        // Потеря материала — провал, только если ученик не отыграл её своим ходом.
                        if (pendingLoss) {
                            if (diff0 < startDiff - 0.5) { end('lost_material'); return true; }
                            pendingLoss = false;
                        }
                        if (used >= limit) { end('moves'); return true; }
                        return false;
                    }
                    if (diff0 < startDiff - 0.5) pendingLoss = true;
                    return false;
                }
                if (goal === 'draw') {
                    if (res && res.over) { end(res.reason === 'checkmate' && !byUser ? 'lost' : 'win'); return true; }
                    var diff = material(st, userColor) - material(st, userColor === 'w' ? 'b' : 'w');
                    if (!byUser && (diff < startDiff - 2.5 || (mv && mv.promotion))) { end('lost_material'); return true; }
                    if (!byUser && used >= limit) { end('win'); return true; }
                    return false;
                }
                // партия
                if (res && res.over) {
                    if (res.reason === 'checkmate') end(byUser ? 'game_win' : 'game_loss');
                    else end('game_draw');
                    return true;
                }
                return false;
            }
            function reply() {
                busy = true;
                info.textContent = api.tt('chess_engine_thinking');
                var fen = R().toFEN(st);
                var p;
                if (step.engine === 'maia') {
                    maiaEng = maiaEng || maia(step.level || 1100);
                    p = maiaEng ? maiaEng.bestMove(fen, { fens: fens.slice() }) : stockfish().then(function (e) { return e.bestMove(fen, { skill: step.skill != null ? step.skill : 3, movetime: 500 }); });
                } else {
                    p = stockfish().then(function (e) { return e.bestMove(fen, { movetime: step.movetime || 450, skill: step.skill != null ? step.skill : 20 }); });
                }
                Promise.resolve(p).then(function (uci) {
                    if (!api.alive() || done) return;
                    var mv = R().moveFromUCI(st, uci);
                    if (!mv) { var any = R().legalMoves(st); mv = any[0]; }
                    if (!mv) return;
                    setTimeout(function () {
                        if (!api.alive() || done) return;
                        setPos(R().applyMove(st, mv), mv);
                        busy = false;
                        if (judge(mv, false)) return;
                        info.textContent = goalLine();
                    }, 250);
                }, function () {
                    busy = false;
                    if (!api.alive()) return;
                    done = true;
                    api.skip(api.tt('chess_engine_missing'));
                });
            }
            function end(kind) {
                bd.b.setInteractive(false);
                busy = false;
                if (goal === 'game') {
                    done = true;
                    api.secondary(null, null);
                    var key = kind === 'game_win' ? 'chess_game_win' : kind === 'game_loss' || kind === 'resign' ? 'chess_game_loss' : 'chess_game_draw';
                    api.answer({ correct: null, explain: api.tt(key) + (t.explain ? '\n\n' + t.explain : '') });
                    return;
                }
                if (kind === 'win') {
                    done = true;
                    api.secondary(null, null);
                    api.answer({ correct: true, score: attempts <= 1 ? 1 : 0.6, explain: t.explain || null });
                    return;
                }
                info.textContent = api.tt('chess_fail_' + kind);
                api.primary(api.tt('chess_restart'), function () { api.primary(null, null); reset(); });
                api.secondary(api.tt('chess_show_idea'), function () {
                    done = true;
                    api.answer({ correct: false, explain: t.explain || null, reveal: t.idea || null });
                });
            }
            if (!window.ChessRules || !window.ChessBoard) { api.skip(api.tt('chess_engine_missing')); return; }
            if (step.engine !== 'maia') stockfish().catch(function () {});
            else maiaEng = maia(step.level || 1100);
            reset();
        }
    });

    /* ── серия задач Lichess ───────────────────────────────────────── */
    K.step('chess-puzzles', {
        reviewable: false,
        mount: function (host, step, api) {
            var t = step.t || {};
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            var count = step.count || 3;
            var info = status(host, api);
            var area = api.el('div');
            host.appendChild(area);
            var n = 0, solved = 0, ses = null, bd = null, st = null, busy = false, finished = false;
            var seen = api.store.get('chess_seen', {}) || {};
            var P = window.ChessPuzzles;
            if (!P) { api.skip(api.tt('chess_engine_missing')); return; }
            info.textContent = api.tt('chess_puzzle_loading');
            P.init(CH.puzzlesIndex).then(function (ok) {
                if (!api.alive()) return;
                if (!ok) { api.skip(api.tt('chess_puzzle_failed')); return; }
                next();
            }, function () { if (api.alive()) api.skip(api.tt('chess_puzzle_failed')); });
            function next() {
                if (n >= count) { finishAll(); return; }
                api.primary(null, null);
                // exclude у ChessPuzzles.pick — функция id → bool, не объект
                P.pick({ rating: step.rating || 900, theme: step.theme || null, exclude: function (id) { return !!seen[id]; } }).then(function (pz) {
                    if (!api.alive()) return;
                    if (!pz) { finishAll(); return; }
                    seen[pz.id] = 1;
                    api.store.set('chess_seen', seen);
                    show(pz);
                }, function () {
                    if (!api.alive()) return;
                    if (n) finishAll(); else api.skip(api.tt('chess_puzzle_failed'));
                });
            }
            function show(pz) {
                area.innerHTML = '';
                ses = P.session(pz);
                st = R().fromFEN(ses.fen);
                var lost = false;
                bd = mkBoard(area, api, {
                    fen: ses.fen,
                    orient: ses.solverColor,
                    movesFor: function (sq) {
                        if (busy || finished || st.turn !== ses.solverColor) return [];
                        var out = [];
                        R().legalMoves(st).forEach(function (mv) {
                            if (R().to64(mv.from) === sq && out.indexOf(R().to64(mv.to)) < 0) out.push(R().to64(mv.to));
                        });
                        return out;
                    },
                    onMove: function (from, to) {
                        if (busy || finished) return;
                        var cands = R().legalMoves(st).filter(function (mv) { return R().to64(mv.from) === from && R().to64(mv.to) === to; });
                        if (!cands.length) return;
                        var go = function (mv) {
                            var r = ses.submit(R().moveToUCI(mv));
                            if (r === 'wrong') {
                                lost = true;
                                bd.b.setPosition(R().applyMove(st, mv), { animate: true });
                                busy = true;
                                setTimeout(function () {
                                    if (!api.alive()) return;
                                    bd.b.setPosition(st, { animate: true });
                                    var exp = ses.expected();
                                    var em = exp && R().moveFromUCI(st, exp);
                                    if (em) bd.b.flashHint(R().to64(em.from), R().to64(em.to));
                                    info.textContent = api.tt('chess_puzzle_wrong', { move: em ? san(st, em) : exp });
                                    busy = false;
                                    endOne(false);
                                }, 650);
                                return;
                            }
                            set(R().applyMove(st, mv), mv);
                            if (r === 'solved') { endOne(!lost); return; }
                            busy = true;
                            setTimeout(function () {
                                if (!api.alive()) return;
                                var rep = R().moveFromUCI(st, ses.reply());
                                if (rep) set(R().applyMove(st, rep), rep);
                                busy = false;
                            }, 550);
                        };
                        if (cands.length > 1) bd.b.askPromotion(st.turn, to & 7, function (type) {
                            var m = cands.filter(function (c) { return c.promotion === type; })[0];
                            if (m) go(m);
                        });
                        else go(cands[0]);
                    }
                });
                info.textContent = api.tt('chess_puzzle_n', { n: n + 1, total: count }) + ' · ' + api.tt('chess_watch');
                busy = true;
                setTimeout(function () {
                    if (!api.alive()) return;
                    if (ses.setup) {
                        var mv = R().moveFromUCI(st, ses.setup);
                        if (mv) set(R().applyMove(st, mv), mv);
                    }
                    busy = false;
                    info.textContent = api.tt('chess_puzzle_n', { n: n + 1, total: count }) + ' · ' + turnLine(api, st);
                }, 700);
            }
            function set(next, mv) {
                st = next;
                bd.b.setPosition(st, { animate: true });
                bd.b.markLastMove(R().to64(mv.from), R().to64(mv.to));
                bd.b.markCheck(R().inCheck(st, st.turn) ? R().to64(R().kingSquare(st.board, st.turn)) : null);
            }
            function endOne(ok) {
                bd.b.setInteractive(false);
                n++;
                if (ok) { solved++; info.textContent = api.tt('chess_puzzle_solved'); }
                var last = n >= count;
                api.primary(last ? api.t('check') : api.tt('chess_puzzle_next'), last ? finishAll : next);
            }
            function finishAll() {
                if (finished) return;
                finished = true;
                var total = Math.max(1, n);
                var score = solved / total;
                api.answer({ correct: score >= 0.6 - 1e-9, score: score, explain: api.tt('chess_puzzles_result', { n: solved, total: total }) + (t.explain ? '\n\n' + t.explain : '') });
            }
        }
    });
})();
